<template>
  <div class="lock-screen" v-if="visible">
    <div class="lock-card">
      <a-icon type="lock" class="lock-icon" />
      <div class="lock-title">屏幕已锁定</div>
      <div class="lock-info">{{ cashierName }} · {{ clock }}</div>
      <a-input-password ref="pwd" v-model="password" placeholder="输入登录密码解锁"
                        @pressEnter="unlock" class="lock-input" />
      <a-button type="primary" block :loading="unlocking" @click="unlock">解锁</a-button>
      <div v-if="failCount" class="lock-fail">密码错误，请重试</div>
    </div>
  </div>
</template>

<script>
  import md5 from 'md5'
  import { mapGetters } from 'vuex'
  import { cashierUnlock } from '@/api/plugin/member'

  /**
   * 锁屏遮罩（F1）：显示收银员+时间，输入登录密码（md5 校验）解锁
   */
  export default {
    name: 'LockScreen',
    props: {
      visible: { type: Boolean, default: false }
    },
    data() {
      return {
        password: '',
        unlocking: false,
        failCount: 0,
        clock: '',
        timer: null
      }
    },
    computed: {
      ...mapGetters(['userInfo']),
      cashierName() {
        const info = this.userInfo || {}
        return info.username || info.realname || '收银员'
      }
    },
    watch: {
      visible(val) {
        if (val) {
          this.password = ''
          this.failCount = 0
          this.tick()
          this.timer = setInterval(this.tick, 1000)
          this.$nextTick(() => {
            if (this.$refs.pwd) this.$refs.pwd.focus()
          })
        } else if (this.timer) {
          clearInterval(this.timer)
        }
      }
    },
    beforeDestroy() {
      if (this.timer) clearInterval(this.timer)
    },
    methods: {
      tick() {
        const d = new Date()
        const p = n => String(n).padStart(2, '0')
        this.clock = `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
      },
      unlock() {
        if (!this.password) {
          return
        }
        this.unlocking = true
        cashierUnlock(md5(this.password)).then(res => {
          if (res && res.code === 200) {
            this.$emit('unlock')
          } else {
            this.failCount++
            this.password = ''
          }
        }).finally(() => {
          this.unlocking = false
        })
      }
    }
  }
</script>

<style scoped>
  .lock-screen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .72);
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .lock-card {
    width: 320px;
    background: #fff;
    border-radius: 10px;
    padding: 32px 28px;
    text-align: center;
  }
  .lock-icon {
    font-size: 40px;
    color: #0081ff;
  }
  .lock-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-top: 10px;
  }
  .lock-info {
    color: #999;
    font-size: 13px;
    margin: 8px 0 18px;
  }
  .lock-input {
    margin-bottom: 14px;
  }
  .lock-fail {
    color: #e4393c;
    font-size: 12px;
    margin-top: 10px;
  }
</style>
